/**
 * FAQ Wallware - TOC scroll tracking
 * Highlights the active category in the sidebar as the user scrolls.
 */
(function () {
  var tocLinks = document.querySelectorAll('[data-faq-toc-link]');
  if (!tocLinks.length) return;

  var sectionIds = [];
  var sections = [];

  tocLinks.forEach(function (link) {
    var id = link.getAttribute('data-faq-toc-link');
    var section = document.getElementById('faq-cat-' + id);
    if (section) {
      sectionIds.push(id);
      sections.push(section);
    }
  });

  if (!sections.length) return;

  // IntersectionObserver for active section highlighting
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id.replace('faq-cat-', '');
        tocLinks.forEach(function (link) {
          link.classList.toggle(
            'is-active',
            link.getAttribute('data-faq-toc-link') === id
          );
        });
      });
    },
    { threshold: 0, rootMargin: '-20% 0px -60% 0px' }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });

  // Smooth scroll with offset on TOC click
  tocLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = link.getAttribute('href').slice(1);
      var target = document.getElementById(targetId);
      if (!target) return;

      var navHeight = 80;
      var top =
        target.getBoundingClientRect().top + window.scrollY - navHeight - 32;

      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });

  // Activate first link on load
  if (tocLinks.length) {
    tocLinks[0].classList.add('is-active');
  }
})();
